import { useInfiniteQuery } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import getV1MFHistory from '@services/api/platform/mutual-fund/history';
import { rewriteStatusMF } from '../../utils/rewriteStatusMF';

function useHistoryMF() {
  const { cb, key } = getV1MFHistory();

  const { data, fetchNextPage, isInitialLoading, isFetchingNextPage } = useInfiniteQuery(key, cb, {
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.data?.next) return allPages.length + 1;
    },
    select: (datas) =>
      datas.pages?.flatMap((page) => {
        const iterateData = page.data.results.map((dataMF) => ({
          ...dataMF,
          mf_name: dataMF?.transaction[0]?.name,
          status_transaction: rewriteStatusMF(
            dataMF?.transaction[0]?.status_transaction,
            dataMF.type,
            dataMF.payment_method_data
          ),
        }));
        return iterateData;
      }),
  });

  useEffect(() => {
    window.testFetchNext = fetchNextPage;
  }, [fetchNextPage]);

  const fetchNext = useCallback(() => {
    if (!isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, isFetchingNextPage]);

  return { data: data || [], isInitialLoading, fetchNextPage: fetchNext, isFetchingNextPage };
}

export default useHistoryMF;
